import { navigationRef as navRef } from '@zet/utils/navigation'

export const navigationRef = navRef
const navigateWithTimeTracking = (screen: string, payload?: object) => {
  navigationRef.navigate(screen as never, (payload as never) || ({} as never))
}

export function navigateTo(name: string, params?: object) {
  if (navigationRef?.isReady()) {
    navigateWithTimeTracking(name, params)
  }
}

export function resetNavigation(name) {
  if (navigationRef?.isReady()) {
    const previousRouteName = navigationRef?.getCurrentRoute()?.name
    const currentRouteName = name
    if (previousRouteName !== currentRouteName) {
      navigationRef.reset({
        index: 0,
        routes: [{ name }],
      })
    }
  }
}

export const updateZetCode = (code: string) => {
  if (!code) return
  else if (!code?.includes('@')) return code

  return code?.replace(/zet@|one@/gi, '')
}

export const appendOneCode = (referralCode: string) => {
  if (!referralCode) return
  if (referralCode?.substring(0, 4)?.toLowerCase() === 'one@')
    return referralCode

  return 'One@' + referralCode
}
